import { Navigate, Route } from 'react-router-dom';

import { signUpRoutes } from 'pages/SignUp/routes';
import { FaroRoutes } from 'utils/faro';

import { Accept } from './Accept';
import { Accepted } from './Accepted';
import { AlreadyAccepted } from './AlreadyAccepted';
import { CreateUser } from './CreateUser';
import { CreateUserFromSSO } from './CreateUserFromSSO';
import { Expired } from './Expired';
import { InvalidUser } from './InvalidUser';
import { invitesRoutes } from './routes';

export const Invites = () => {
  return (
    <FaroRoutes>
      <Route path={invitesRoutes.relative.accept} element={<Accept />} />
      <Route path={invitesRoutes.relative.accepted} element={<Accepted />} />
      <Route path={invitesRoutes.relative.createUser} element={<CreateUser />} />
      <Route path={invitesRoutes.relative.createUserFromSSO} element={<CreateUserFromSSO />} />
      <Route path={invitesRoutes.relative.expired} element={<Expired />} />
      <Route path={invitesRoutes.relative.invalidUser} element={<InvalidUser />} />
      <Route path={invitesRoutes.relative.alreadyAccepted} element={<AlreadyAccepted />} />
      <Route index element={<Navigate replace to={signUpRoutes.base} />} />
    </FaroRoutes>
  );
};
